import { FileMaceClaimAction, ErrorStep, PreventSubmit } from './types';
import {
  InsertMaceClaimDto,
  SubmitMaceClaimDto,
  InsertComplaintAndTroubleshootDto,
  UpdateCustomerInfoDto,
  UpdateProductInfo,
} from '@/core-types/file-mace-claim';
import { DeleteDamageDto, InsertDamageDto } from '@/core-types/damage';
import { MaceClaim } from '@/core-types/claim';

export const insertMaceClaim = (payload: InsertMaceClaimDto) =>
  ({
    type: FileMaceClaimAction.INSERT_CLAIM,
    payload,
  } as const);

export const updateCustomerInfo = (payload: UpdateCustomerInfoDto) =>
  ({
    type: FileMaceClaimAction.UPDATE_CUSTOMER_INFO,
    payload,
  } as const);

export const insertComaplaintAndTroubleShooting = (payload: InsertComplaintAndTroubleshootDto) =>
  ({
    type: FileMaceClaimAction.INSERT_COMPLAIT_AND_TROUBLESHOOT,
    payload,
  } as const);

export const updateActiveMaceClaim = (payload: Partial<MaceClaim>) =>
  ({
    type: FileMaceClaimAction.UPDATE_ACTIVE_CLAIM,
    payload,
  } as const);

export const setPreventSubmitMaceClaim = (payload: PreventSubmit) =>
  ({
    type: FileMaceClaimAction.SET_PREVENT_SUBMIT_CLAIM,
    payload,
  } as const);

export const removePreventSubmitMaceClaim = (payload: PreventSubmit) =>
  ({
    type: FileMaceClaimAction.REMOVE_PREVENT_SUBMIT_CLAIM,
    payload,
  } as const);

export const setErrorSteps = (payload: ErrorStep) =>
  ({
    type: FileMaceClaimAction.SET_ERROR_STEPS,
    payload,
  } as const);

export const removeErrorSteps = (payload: ErrorStep) =>
  ({
    type: FileMaceClaimAction.REMOVE_ERROR_STEPS,
    payload,
  } as const);

export const clearErrorSteps = (payload: ErrorStep) =>
  ({
    type: FileMaceClaimAction.CLEAR_ERROR_STEPS,
    payload,
  } as const);

export const removeActiveMaceClaim = () =>
  ({
    type: FileMaceClaimAction.REMOVE_ACTIVE_CALIM,
  } as const);

export const insertMaceClaimItemDamage = (payload: InsertDamageDto[]) =>
  ({
    type: FileMaceClaimAction.INSERT_CLAIM_ITEM_DAMAGE,
    payload,
  } as const);

export const submitMaceClaim = (payload: SubmitMaceClaimDto) =>
  ({
    type: FileMaceClaimAction.SUBMIT_CLAIM,
    payload,
  } as const);

export const deleteDamage = (payload: DeleteDamageDto) =>
  ({
    type: FileMaceClaimAction.DELETE_DAMAGE,
    payload,
  } as const);

export const insertMaceWarrantyItem = (payload: UpdateProductInfo) =>
  ({
    type: FileMaceClaimAction.INSERT_WARRANTY_ITEM,
    payload,
  } as const);

// export const deleteMaceClaimItem = (payload: DeleteMaceClaimItemDto) =>
//   ({
//     type: FileMaceClaimAction.DELETE_CLAIM_ITEM,
//     payload,
//   } as const);
